import { generateUtilityClass, generateUtilityClasses } from '@mui/core';
export function getTabUtilityClass(slot) {
  return generateUtilityClass('MuiTab', slot);
}
const tabClasses = generateUtilityClasses('MuiTab', ['root', 'labelIcon', 'textColorInherit', 'textColorPrimary', 'textColorSecondary', 'selected', 'disabled', 'fullWidth', 'wrapped']);
export default tabClasses;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/Tab/tabClasses.js
// module id = 825
// module chunks = 0